module.exports = __webpack_public_path__ + "fonts/Avant-Garde-Gothic-Book-Regular.52700c1.otf";